import React from 'react';
import { Button } from '.';
export default function PreviewEditReportTextButton(_ref) {
  let {
    settings = {},
    toggleHookHighlight,
    setVisibleModalKey
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    title: "Edit report text",
    variant: "light",
    className: `button-for-${settings.key} p-2 d-inline-flex rounded-circle me-2`,
    key: settings.key,
    onMouseEnter: () => toggleHookHighlight(true),
    onMouseOut: e => {
      if (!['PATH', 'SVG', 'BUTTON'].includes(e.relatedTarget.tagName.toUpperCase())) {
        toggleHookHighlight(false);
      }
    },
    onClick: () => {
      console.log(`setting visible modal to ${settings.key}-modal`);
      setVisibleModalKey(`${settings.key}-modal`);
    },
    style: {
      position: 'absolute',
      top: settings.top,
      left: settings.left,
      transform: 'translateY(-50%)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 text-info rounded-circle mx-auto",
    onMouseEnter: () => toggleHookHighlight(true),
    style: {
      height: '1rem',
      width: '1rem'
    }
  }, "edit"));
}